/* eslint-disable react-hooks/exhaustive-deps */

import {
  I2cDatePicker,
  I2cCurrencyInput,
  I2cRadioGroup,
  I2cRadioButton,
  I2cInput,
  I2cTextarea,
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect } from "react";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import "../Prepaid.scss";

export const currencySymbolMap = {
  USD: "$",
  EUR: "€",
  CAD: "C$",
};

export const currencies = [
  { label: "USD", value: "USD" },
  { label: "EUR", value: "EUR" },
  { label: "CAD", value: "CAD" },
];
/**
 * Component for capturing and validating project details.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Function} props.setFormValidStates - Function to set form validation states.
 * @returns {React.Component} - The rendered component.
 */
const ContractAndPaymentTerms = ({
  setFormValidStates,
  setAddFormData,
  addFormData,
  formDataJson,
  isFetching,
}) => {
  // Define validation schema using Zod
  const validationSchema = z.object({
    cpt_contract_status: z
      .string()
      .optional(),
    cpt_expiryDate: z
      .string()
      .optional(),
    cpt_setupCost: z.preprocess(
      (val) => {
        if (val === "" || val === null || val === undefined) return undefined;
        return Number(val);
      },
      z
        .number({
          invalid_type_error: "Setup cost must be a valid number",
        })
        .refine((val) => !isNaN(val), { message: "Setup cost must be a valid number" })
        .optional()
    ),
    cpt_minStartDate: z.string().optional(),
    cpt_additional_information: z.string().optional(),
    cpt_payment_terms: z.string().optional(),
    cpt_type_of_i2c_pricing: z
      .string()
      .optional(),
  });

  // Initialize React Hook Form with Zod resolver
  const methods = useForm({
    resolver: zodResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      cpt_contract_status: "",
      cpt_expiryDate: "",
      cpt_setupCost: "",
      cpt_setupCostCurrency: "USD",
      cpt_minStartDate: "",
      cpt_additional_information: "",
      cpt_payment_terms: "",
      cpt_type_of_i2c_pricing: "",
    },
  });


  const fields = [
    "cpt_contract_status",
    "cpt_expiryDate",
    "cpt_setupCost",
    "cpt_setupCostCurrency",
    "cpt_minStartDate",
    "cpt_additional_information",
    "cpt_payment_terms",
    "cpt_type_of_i2c_pricing",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[0]["0_1"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  useEffect(() => {
    methods.trigger();
    setFormValidStates("0_1", true);
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      0: {
        ...addFormData["0"],
        "0_1": { ...values },
      },
    });
  };
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("0_1", true);
    else setFormValidStates("0_1", false);
  }, [Object.keys(errors).length]);

  // useEffect(() => {
  //   const errorsLength = Object.keys(errors).length;
  //   setFormValidStates("1_1", errorsLength === 0);
  // }, [Object.keys(errors).length, setFormValidStates]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-column-sm gap-row-md">
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <div className="custom-label-light mb-8">
                Contract Status
              </div>
              <Controller
                name="cpt_contract_status"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    className="radio-custom-width"
                    value={methods.watch("cpt_contract_status")}
                    {...field}
                    name="cpt_contract_status"
                    size="large"
                  >
                    {[
                      { label: "Agreement", value: "agreement" },
                      {
                        label: "Letter of Intent (LOI)",
                        value: "letter-of-intent",
                      },
                      {
                        label: "N/A",
                        value: "n/a",
                      },
                    ].map((cp, index) => (
                      <I2cRadioButton
                        key={index}
                        onClick={(e) => {
                          field.onChange(e);
                          handleValueChanges();
                        }}
                        value={cp.value}
                      >
                        {cp.label}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.cpt_contract_status &&
                    methods.formState.touchedFields.cpt_contract_status
                    ? true
                    : false
                }
                message={errors.cpt_contract_status?.message ?? "Invalid input"}
              />
            </div>
          </div>

          {/* <div i2c-grid='6'>
					<div className='single-field-wrapper'>
						<Controller
							name='cpt_contract_status'
							control={control}
							render={({ field }) => (
								<I2cSelect
									{...field}
									name='cpt_contract_status'
									label='Contract Status'
									// required
									placeholder='Select Contract Status'
									onI2cChange={(e) => {
										methods.setValue("cpt_contract_status", e.target.value);
										handleValueChanges();
									}}
									value={methods.watch("cpt_contract_status")}
								>
									<I2cMenuItem key={"aggrement"} value='Agreement'>
										Agreement
									</I2cMenuItem>
									<I2cMenuItem key={"loi"} value='Letter of Intent (LOI)'>
										Letter of Intent (LOI)
									</I2cMenuItem>
								</I2cSelect>
							)}
						/>
						<ErrorMessage
							show={
								errors.cpt_contract_status &&
								methods.formState.touchedFields.cpt_contract_status
									? true
									: false
							}
							message={errors.cpt_contract_status?.message ?? "Invalid input"}
						/>
					</div>
				</div> */}
          <div i2c-grid="6@md">
            <div className="single-field-wrapper">
              <div className="custom-label mb-6">
                Expiry Date
              </div>
              <Controller
                name="cpt_expiryDate"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cDatePicker
                      {...field}
                      name="cpt_expiryDate"
                      rotateIcon
                      suffix='<i2c-icon name="linear-calendar-2" slot="suffix" class="suffix-iCon4"></i2c-icon>'
                      hoist
                      placeholder="Enter Expiry Date"
                      errorMessageInvisible={true}
                      size="large"
                      I2cDatePicker
                      required
                      minDate={new Date().setHours(0, 0, 0, 0)}
                      label=""
                      dateFormat="F d, Y"
                      onI2cDateApply={(e) => {
                        if (e.target?.appliedDate)
                          field.onChange(
                            e.target?.appliedDate[0]?.toDateString() ?? "",
                          );
                        else field.onChange("");
                        handleValueChanges();
                      }}
                      defaultDate={
                        methods.watch("cpt_expiryDate")
                          ? new Date(methods.watch("cpt_expiryDate"))
                          : ""
                      }
                    ></I2cDatePicker>
                    <span slot="label"></span>
                  </>
                )}
              />
              {/* <ErrorMessage
                show={
                  errors.cpt_expiryDate &&
                  methods.formState.touchedFields.cpt_expiryDate
                    ? true
                    : false
                }
                message={errors.cpt_expiryDate?.message ?? "Invalid input"}
              /> */}
            </div>
          </div>
          <div i2c-grid="6@md">
            <div className="single-field-wrapper">
              <div className="custom-label mb-6">
                Setup Cost
              </div>
              {/* <Controller
                name="cpt_setupCost"
                control={control}
                render={({ field }) => (
                  <>
               
                    <I2cCurrencyInput
                      {...field}
                      name="cpt_setupCost"
                      id="currencyInput"
                      size="large"
                      currencySymbolOption={"symbol"}
                      _availableCurrencies={["USD", "EUR", "CAD"]}
                      required
                      className="currency-input"
                      onI2cChange={(e) => {
                        field.onChange(e.target.value);
                        handleValueChanges();
                      }}
                      value={methods.watch("cpt_setupCost")}
                      currency={methods.watch("cpt_setupCostCurrency")}
                      onI2cCurrencyChange={(e) => {
                        const selectedCurrency = e.target.currency; 
                        const currencySymbol = currencySymbolMap[selectedCurrency] || "$";
                        const currency = currencies.find(
                          (cur) => cur.value === selectedCurrency,
                        )?.label || selectedCurrency;
                        methods.setValue("cpt_setupCostCurrency", currency);
                        handleValueChanges();
                      }}
                    />
                  </>
                )}
              /> */}
              <Controller
                name="cpt_setupCost"
                control={control}
                render={({ field }) => (
                  <I2cCurrencyInput
                    {...field}
                    name="cpt_setupCost"
                    id="currencyInput"
                    size="large"
                    currencySymbolOption="symbol"
                    _availableCurrencies={["USD", "EUR", "CAD"]}
                    className="currency-input"
                    value={field.value}
                    onI2cChange={(e) => {
                      field.onChange(e.target.value);
                      handleValueChanges();
                    }}
                    currency={methods.getValues("cpt_setupCostCurrency")}
                    onI2cCurrencyChange={(e) => {
                      const selectedCurrency = e.target.currency;
                      methods.setValue("cpt_setupCostCurrency", selectedCurrency);
                      handleValueChanges();
                    }}
                  />
                )}
              />

              <ErrorMessage
                show={
                  !!errors.cpt_setupCost &&
                  methods.formState.touchedFields.cpt_setupCost
                }
                message={errors.cpt_setupCost?.message ?? "Invalid input"}
              />

            </div>
          </div>
          <div i2c-grid="6@md">
            <div className="single-field-wrapper">
              <Controller
                name="cpt_minStartDate"
                control={control}
                render={({ field }) => (
                  <I2cDatePicker
                    {...field}
                    name="cpt_minStartDate"
                    rotateIcon
                    errorMessageInvisible={true}
                    suffix='<i2c-icon name="linear-calendar-2" slot="suffix" class="suffix-iCon4"></i2c-icon>'
                    label="Monthly Minimum Start Date"
                    hoist
                    I2cDatePicker
                    placeholder="Enter Project Go-Live date"
                    onI2cDateApply={(e) => {
                      if (e.target?.appliedDate)
                        field.onChange(
                          e.target?.appliedDate[0]?.toDateString() ?? "",
                        );
                      else field.onChange("");
                      handleValueChanges();
                    }}
                    dateFormat="F d, Y"
                    size="large"
                    defaultDate={
                      methods.watch("cpt_minStartDate")
                        ? new Date(methods.watch("cpt_minStartDate"))
                        : ""
                    }
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.cpt_minStartDate &&
                    methods.formState.touchedFields.cpt_minStartDate
                    ? true
                    : false
                }
                message={errors.cpt_minStartDate?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="6@md">
            <div className="single-field-wrapper">
              <Controller
                name="cpt_payment_terms"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    placeholder="EnterPayment Terms"
                    onI2cInput={(e) => {
                      const value = e.target.value;
                      field.onChange(value);
                      handleValueChanges();
                    }}
                    size="large"
                    label="Payment Terms"
                    name={"cpt_payment_terms"}
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.cpt_payment_terms &&
                    methods.formState.touchedFields.cpt_payment_terms
                    ? true
                    : false
                }
                message={errors.cpt_payment_terms?.message ?? "Invalid input"}
              />
            </div>
          </div>
          <div i2c-grid="6@md">
            <div className="single-field-wrapper">
              <Controller
                name="cpt_additional_information"
                control={control}
                render={({ field }) => (
                  <I2cTextarea
                    {...field}
                    name="cpt_additional_information"
                    onI2cInput={(e) => {
                      field.onChange(e.target.value);
                      handleValueChanges();
                    }}
                    label="Additional Information"
                    placeholder="Enter Additional Information"
                  />
                )}
              />
              <ErrorMessage
                show={
                  errors.cpt_additional_information &&
                    methods.formState.touchedFields.cpt_additional_information
                    ? true
                    : false
                }
                message={
                  errors.cpt_additional_information?.message ?? "Invalid input"
                }
              />
            </div>
          </div>
          <div i2c-grid="6@md">
            <div className="single-field-wrapper">
              <div className="custom-label-light mb-6">
                {" "}
                Type of i2c Inc. Pricing Selected {" "}
              </div>
              <Controller
                name="cpt_type_of_i2c_pricing"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("cpt_type_of_i2c_pricing")}
                    {...field}
                    name="cpt_type_of_i2c_pricing"
                  >
                    {[
                      { label: "Event", value: "event" },
                      {
                        label: "Bundle",
                        value: "bundle",
                      },
                      { label: "N/A", value: "n/a" },
                    ].map((cp, index) => (
                      <I2cRadioButton
                        key={index}
                        onClick={(e) => {
                          field.onChange(e);
                          handleValueChanges();
                        }}
                        value={cp.value}
                      >
                        {cp.label}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.cpt_type_of_i2c_pricing &&
                    methods.formState.touchedFields.cpt_type_of_i2c_pricing
                    ? true
                    : false
                }
                message={
                  errors.cpt_type_of_i2c_pricing?.message ?? "Invalid input"
                }
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContractAndPaymentTerms;
